import { EnviromentTyping } from "./enviroment-typings";

export const environment: EnviromentTyping = {
  production: true,
  apiUrl: {
    identity: "https://one.api.semco.app/identity",
    orga: "https://one.api.semco.app/orga",
    data: "https://one.api.semco.app/data",
    tech: "https://one.api.semco.app/tech",
    pageDefaultSize: 25,
    defaultTimeoutSec: 30,
    tokenExpireOffsetSec: 59
  },
  lang: {
    defaultLanguage: "de-DE",
    useBrowserLanguage: false
  },
  idle: {
    autoRefreshOnViewAfter: 1000 * 60 * 2,
    idleTime: 60 * 20
  },
  alert: {
    batteryStatusAlertLevel: 20
  },
  image: {
    formImageResizeMaxSize: 1366
  },
  interceptor: {
    additionalHttpApiClientInterceptorsIdentifier: "additionalHttpApiClientInterceptors",
    apiPageDefaultSizeIdentifier: "apiPageDefaultSize",
    apiDefaultTimeoutSecIdentifier: "apiDefaultTimeoutSec"
  }
};
